
import React, { useState } from 'react';
import styles from '../../src/assets/scss/PermissionsTable.module.scss';
import inventoryStyles from '../../src/assets/scss/InventoryManagement/InventoryTable.module.scss';
import settingStyles from '../../src/assets/scss/Settings/Settings.module.scss';
import { FaEdit, FaTrash } from 'react-icons/fa';
import Pagination from '../Components/Common/Pagination';
import { useNavigate } from 'react-router-dom';
import DeleteConfirmModal from '../Components/Common/DeleteConfirmModal';
import {
    useGetPermissionQuery,
    useDeletePermissionMutation,
} from '../slices/admin/admin';
import { toast } from 'react-toastify';

const PermissionsTable = () => {
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState('');
    const [permissionFilter, setPermissionFilter] = useState('');
    const [limit, setLimit] = useState(10); // rows per page
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedPermissionId, setSelectedPermissionId] = useState(null);

    const parsedLimit = parseInt(limit, 10);
    const offset = (currentPage - 1) + 1;

    const { data: permissionTableDatas, isLoading } = useGetPermissionQuery({
        offset,
        limit: parsedLimit,
        isActive: statusFilter,
        search: permissionFilter,
    });



    const [deletePermission] = useDeletePermissionMutation();

    if (isLoading) return <div>Loading...</div>;

    const permissions = permissionTableDatas?.result || [];
    const total = permissionTableDatas?.total || 0;
    const totalPages = Math.ceil(total / limit);

    const handleAddPermission = () => {
        navigate('/dashboard/Permission');
    };

    const handleEdit = (permission) => {
        navigate('/dashboard/Permission', {
            state: {
                mode: 'edit',
                data: permission,
            },
        });
    };

    const handleDelete = (id) => {
        setSelectedPermissionId(id);
        setModalOpen(true);
    };

    const confirmDelete = async () => {
        try {
            await deletePermission(selectedPermissionId).unwrap();
            toast.success('Permission deleted successfully!');
        } catch (error) {
            const errMsg = error?.data?.message || 'Failed to delete permission.';
            toast.error(errMsg);
        } finally {
            setModalOpen(false);
            setSelectedPermissionId(null);
        }
    };

    const getStatusText = (isActive) => (isActive ? 'Active' : 'In Active');
    const getStatusStyle = (isActive) => (isActive ? styles.active : styles.inactive);
    const getPermissionColor = (type) => {
        switch (type?.toLowerCase()) {
            case 'fullaccess':
                return 'red';
            case 'view only':
            case 'readonly':
                return 'blue';
            default:
                return 'green';
        }
    };

    return (
        <div className={inventoryStyles.inventoryContainer}>
            <div className={settingStyles.headerRow}>
                <h2 className={settingStyles.header}>Permission</h2>
            </div>
            <div className={styles.container}>
                <div className={styles.title}>
                    <div className={styles.header}>
                    <div className={styles.filters}>
                        <div className={styles.filtersflex}>
                            {/* <select
                                className={styles.inputs}
                                value={permissionFilter}
                                onChange={(e) => {
                                    setPermissionFilter(e.target.value);
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="">All Permissions</option>
                                {[...new Set(permissions.map((perm) => perm.permissionName))].map(
                                    (name, idx) => (
                                        <option key={idx} value={name}>
                                            {name}
                                        </option>
                                    )
                                )}
                            </select> */}
                            <input
                                type="text"
                                placeholder="Search by permission name..."
                                className={styles.input}
                                value={permissionFilter}
                                onChange={(e) => {
                                    setPermissionFilter(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />

                        </div>
                        <div className={styles.filtersflex}>
                            <select
                                className={styles.inputs}
                                value={statusFilter}
                                onChange={(e) => {
                                    setStatusFilter(e.target.value);
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="">All Status</option>
                                <option value="true">Active</option>
                                <option value="false">In Active</option>
                            </select>
                        </div>
                        <div>
                            <button
                                className={styles.clearBtn}
                                onClick={() => {
                                    setPermissionFilter('');
                                    setStatusFilter('');
                                    setCurrentPage(1);
                                }}
                            >
                                Clear Filters
                            </button>

                        </div>
                    </div>
                    <button className={styles.addBtn} onClick={handleAddPermission}>
                        + Add Permission
                    </button>
                </div>

                <div className={styles.table}>
                    <div className={`${styles.row} ${styles.headerRow}`}>
                        <div><input type="checkbox" /></div>
                        <div>Permission Name</div>
                        <div>Permission Type</div>
                        <div>Description</div>
                        <div>Status</div>
                        <div></div>
                    </div>


                    {permissions.length > 0 ? (
                        permissions.map((permission, index) => (
                            <div className={styles.row} key={permission._id || index}>
                                <div><input type="checkbox" /></div>
                                <span
                                    className={`${styles.roleBadge} ${styles[getPermissionColor(
                                        permission.permissionType
                                    )]}`}
                                >
                                    {permission.permissionName}
                                </span>
                                <div>{permission.permissionType}</div>
                                <div>{permission.description}</div>
                                <div className={getStatusStyle(permission.isActive)}>
                                    {getStatusText(permission.isActive)}
                                </div>
                                <div className={styles.actions}>
                                    <FaTrash className={styles.icon} onClick={() => handleDelete(permission._id)} />
                                    <FaEdit className={styles.icon} onClick={() => handleEdit(permission)} />
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className={styles.noData}>No records found</div>
                    )}

                </div>

                <div className={styles.paginationWrapper}>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                    <select
                        className={styles.inputsbtn}
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={10}>10 rows</option>
                        <option value={25}>25 rows</option>
                        <option value={50}>50 rows</option>
                    </select>
                </div>
            </div>

            <DeleteConfirmModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={confirmDelete}
            />
            </div>
        </div>
    );
};

export default PermissionsTable;


